var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStepCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1211 1.54879C22.9315 2.17749 23.1677 3.38029 22.6524 4.30729C18.6544 11.4994 15.0165 16.2848 12.8667 18.8462C11.7105 20.224 9.8513 20.4007 8.54021 19.1986C6.66843 17.4824 3.91744 14.5687 1.28479 10.3247C0.788651 9.52489 0.89612 8.45849 1.51439 7.76689L3.09959 5.99379C3.83761 5.16839 5.0507 5.14569 5.79501 5.96439C8.41618 8.84779 10.4491 11.4624 10.4491 11.4624C10.4491 11.4624 13.4364 6.60579 18.0753 0.717394C18.7164 -0.0965064 19.8225 -0.234106 20.6246 0.387994L22.1211 1.54879Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepCheckmark);
export default __webpack_public_path__ + "static/media/stepCheckmark.b79653b097637bacc1689da03976c25d.svg";
export { ForwardRef as ReactComponent };